import { Stack, TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';
import { forceString } from 'src/utils/forceString';
interface ImageFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const ImageField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: ImageFieldProps) => {
  const imageData = (() => {
    const source = field.dataSource || (field as any).properties?.dataSource;
    if (!source) return { src: '', width: '', height: '' };
    try {
      return JSON.parse(forceString(source));
    } catch {
      return { src: '', width: '', height: '' };
    }
  })();

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Image URL"
        value={imageData.src || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            dataSource: JSON.stringify({
              ...imageData,
              src: e.target.value,
            }),
          })
        }
        required
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter the URL of the image"
      />
      <TextField
        fullWidth
        label="Width"
        value={imageData.width || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            dataSource: JSON.stringify({
              ...imageData,
              width: e.target.value,
            }),
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter width (e.g. 100px, 50%)"
      />
      <TextField
        fullWidth
        label="Height"
        value={imageData.height || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            dataSource: JSON.stringify({
              ...imageData,
              height: e.target.value,
            }),
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter height (e.g. 100px, 50%)"
      />
    </Stack>
  );
};
